<template>
  <div class="animate__animated animate__fadeIn archived-list-page">
    <div class="search-block d-flex justify-content-between align-items-center">
      <el-form
        class="w-100"
        ref="formSearch"
        :model="tableRules.dataSearch.value"
        :rules="tableRules.dataSearch.valid"
        label-position="top"
        @submit.native.prevent
      >
        <b-row>
          <b-col md="10" class="pl-0 searchBox-container">
            <el-input
              class="searchBox"
              prefix-icon="fal fa-search"
              clearable
              v-model="dataSearchVnText"
              placeholder="Tìm kiếm hợp đồng lưu trữ"
              @keyup.enter.native="fn_tableSearch"
              @clear="fn_tableSearch"
            ></el-input>
          </b-col>
          <b-col md="2">
            <el-button
              @click="fn_createArcived()"
              class="btn__doc btn-default button-w100"
            >
              Thêm mới
            </el-button>
          </b-col>
        </b-row>
      </el-form>
    </div>
    <div class="table-block mt-3">
      <el-table
        class="archived-table"
        :data="tableRules.data"
        border
        style="width: 100%"
      >
        <el-table-column label="STT" width="70" align="center">
          <template slot-scope="scope">
            {{ tableRules.offset + scope.$index + 1 }}
          </template>
        </el-table-column>
        <el-table-column prop="name" label="Tên văn bản" min-width="220">
          <template slot-scope="scope">
              <span
                :title="scope.row.name"
              >
                {{ scope.row.name }}
              </span>
          </template>
        </el-table-column>
        <el-table-column prop="code" label="Số văn bản" align="center" width="200">
          <template slot-scope="scope">
              <span
                :title="scope.row.code"
              >
                {{ scope.row.code }}
              </span>
          </template>
        </el-table-column>
        <el-table-column prop="document_category_name" label="Loại văn bản" min-width="150">
          <template slot-scope="scope">
              <span
                :title="scope.row.document_category_name"
              >
                {{ scope.row.document_category_name }}
              </span>
          </template>
        </el-table-column>
        <el-table-column prop="description" label="Ghi chú" min-width="250">
          <template slot-scope="scope">
              <span
                :title="scope.row.description"
              >
                {{ scope.row.description }}
              </span>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          label="Thao tác"
          width="180"
        >
          <template slot-scope="scope">
            <el-button
              class="button-action view"
              v-b-popover.hover.left="'Chi tiết'"
              @click="fn_handle('view', scope.row.id)"
            >
              <i class="icon isax-eye"></i>
            </el-button>
            <el-button
              class="button-action edit"
              v-b-popover.hover.left="'Sửa'"
              @click="fn_handle('edit', scope.row.id)"
            >
              <i class="icon isax-edit-2"></i>
            </el-button>
            <el-button
              class="button-action delete"
              v-b-popover.hover.left="'Xóa'"
              @click="fn_handle('delete', scope.row.id)"
            >
              <i class="icon icon24-Delete"></i>
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <b-row class="mt-2">
        <b-col md="12" class="text-right">
          <el-pagination
            @size-change="fn_tableSizeChange"
            @current-change="fn_tableCurentChange"
            @prev-click="fn_tablePrevClick"
            @next-click="fn_tableNextClick"
            :page-sizes="tableRules.lengthMenu"
            :page-size="tableRules.limit"
            :current-page="tableRules.page"
            background
            layout="total, sizes, prev, pager, next, jumper"
            :total="tableRules.total"
            :pager-count="5"
          ></el-pagination>
        </b-col>
      </b-row>
    </div>
  </div>
</template>
<script>
import MethodService from "../../../../service/MethodService"
import LanguageService from "../../../../service/LanguageService"
import ArchivedModel from './ArchivedModel'
import DatePicker from "vue2-datepicker"
import DdaScanFilesApi from '../../../../moduleApi/DdaScanFilesApi'
export default {
  components: {
    DatePicker,
  },
  data() {
    return {
      lang: {
        formatLocale: {
          firstDayOfWeek: 1,
        },
        monthBeforeYear: false,
      },
      MethodService,
      LanguageService,
      heightTable: 400,
      tableRules: MethodService.copyObject(ArchivedModel.tableRules),
      dataSearchVnText: undefined,
    }
  },
  methods: {
    async fn_getDataTable() {
      let dataFilter = {
        sort: this.tableRules.sort,
        limit: this.tableRules.limit,
        offset: this.tableRules.offset,
        vn_text: this.dataSearchVnText
      }
      this.replaceRoute()
      const resApi = await DdaScanFilesApi.list(dataFilter)
      if (resApi.result.length > 0) {
        this.tableRules.total = resApi.meta.total
        this.tableRules.page =
        this.tableRules.offset / this.tableRules.limit + 1
        this.fn_reRender(resApi.result)
      } else {
        this.fn_reRender([])
      }
    },
    fn_reRender(resData) {
      this.tableRules.data = resData
      if (
        (this.tableRules.offset == this.tableRules.total && this.tableRules.page > 1) ||
        (resData.length == 0 && this.tableRules.page > 1)
      ) {
        this.tableRules.page = this.tableRules.page - 1
        this.tableRules.offset =
          (this.tableRules.page - 1) * this.tableRules.limit
          this.fn_getDataTable()
      }
    },
    replaceRoute() {
      this.$router.replace({
        name: 'Admin-Document-Archived-list',
        query: {
          limit: this.tableRules.limit,
          page: this.tableRules.page,
          sort: this.tableRules.sort,
          filters: this.tableRules.filters,
          vn_text: this.dataSearchVnText
        }
      }).catch(() => {})
    },
    fn_createArcived() {
      this.$router.push({
        name: 'Admin-Document-Archived-create'
      }).catch(() => {})
    },
    fn_handle(type, rowId) {
      if (type == 'view' || type == 'edit')
        this.$router.push({
          name: `Admin-Document-Archived-${type == 'view' ? 'detail' : 'update'}`,
          params: {
            id: rowId
          }
        })
      if (type == 'delete')
        this.$confirm(LanguageService.lang.c_deleteConfirm, {
          confirmButtonText: LanguageService.lang.c_agree,
          cancelButtonText: LanguageService.lang.c_cancel,
          type: "warning",
        })
        .then(() => {
          this.fn_delete(rowId)
        })
        .catch(() => {})
    },
    async fn_delete(id) {
      try {
        const resDelete = await DdaScanFilesApi.delete(id)
        if (resDelete.result > 0) {
          toastr.success("Xóa thành công")
          this.fn_getDataTable()
        } else {
          toastr.error("Xóa thất bại")
        }
      } catch (error) {
        toastr.error("Xóa thất bại")
      }
    },
    //Search
    fn_tableShowFormSearch() {
      this.tableRules.showFormSearch = !this.tableRules.showFormSearch
      if (this.tableRules.showFormSearch) {
        this.heightTable = window.innerHeight - 390
      } else {
        this.heightTable = window.innerHeight - 300
      }
      let query = Object.assign({}, this.$route.query)
      query.showFormSearch = this.tableRules.showFormSearch
      this.$router
        .replace({
          name: "Admin-" + this.moduleName + "-list",
          query: query,
        })
        .catch((err) => {});
    },
    fn_tableSearch() {
      this.fn_getDataTable()
    },
    //Pagination
    fn_tableSizeChange(limit) {
      this.tableRules.limit = limit;
      this.fn_tableChangeOffset(this.tableRules.page);
    },
    fn_tableCurentChange(page) {
      this.fn_tableChangeOffset(page);
    },
    fn_tablePrevClick(page) {
      this.fn_tableChangeOffset(page);
    },
    fn_tableNextClick(page) {
      this.fn_tableChangeOffset(page);
    },
    fn_tableChangeOffset(page) {
      this.tableRules.page = page;
      this.tableRules.offset =
        (this.tableRules.page - 1) * this.tableRules.limit;
      this.fn_getDataTable();
    },
    fn_hashUrl() {
      if (this.$route.query.limit) this.tableRules.limit = parseInt(this.$route.query.limit)
      if (this.$route.query.page) this.tableRules.page = parseInt(this.$route.query.page)
      if (this.$route.query.limit && this.$route.query.page) this.tableRules.offset = (this.tableRules.page - 1) * this.tableRules.limit
      if (this.$route.query.sort) {
        this.tableRules.sort = this.$route.query.sort
        this.tableRules.defaultSort[0] = this.tableRules.sort;
        if (this.tableRules.sort.indexOf("-") != -1) {
          this.tableRules.defaultSort[1] = "descending";
        } else {
          this.tableRules.defaultSort[1] = "ascending";
        }
      }
      if (this.$route.query.filters) this.tableRules.filters = this.$route.query.filters
      if (this.$route.query.vn_text) this.dataSearchVnText = this.$route.query.vn_text
    }
  },
  created() {
    this.fn_hashUrl()
    this.fn_getDataTable()
  }
}
</script>
<style lang="scss" scoped>
.archived-list-page {
  padding: 2px 2px 0;
}

.table-block {
  background: var(--white);
  padding: 14px 16px 16px;
  border-radius: 8px;
  box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.08);
  height: calc(100vh - 170px);
}

.search-block {
  margin-bottom: 12px;
}

.searchBox-container {
  position: relative;
}

::v-deep .searchBox {
  .el-input__inner {
    border: 1px solid #f0c39f !important;
    box-shadow: 0px 2px 4px rgb(0 0 0 / 16%) !important;
    border-radius: 6px !important;
    height: 40px;
    &:focus {
      border-color: var(--orange) !important;
    }
  }
}

::v-deep .el-input__prefix {
  .el-input__icon.fa-search {
    margin-left: 8px;
    color: var(--orange);
  }
}

::v-deep .btn-default.button-w100 {
  background: var(--orange) !important;
  border-color: var(--orange) !important;
  color: #fff !important;
  &:hover,
  &:focus {
    opacity: 0.92;
  }
}

::v-deep .archived-table {
  border-radius: 6px 6px 0 0;
  overflow: hidden;
  .el-table__header-wrapper th {
    background-color: #e8914a;
    color: #fff;
    font-weight: 600;
  }
  .el-table__row:hover > td {
    background: #fff7f0 !important;
  }
}
.button-action {
  padding: 6px;
  border: none;
  background: transparent;
  &.view {
    color: var(--orange);
    &:hover {
      color: var(--orange) !important;
    }
  }
  &.edit {
    color: var(--orange);
    &:hover {
      color: var(--orange) !important;
    }
  }
  &.delete {
    color: var(--orange);
    &:hover {
      color: var(--orange) !important;
    }
  }
}

::v-deep .el-pagination {
  padding-top: 4px;
}

::v-deep .el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: var(--orange);
  color: #fff;
}
</style>
